export function pinterestTrackEvent(track, eventName, payload) {
  if (window.environment == 'production') {
    if (typeof pintrk != 'function') {
      setTimeout(() => {
        pinterestTrackEvent(track, eventName, payload);
      }, 500);
    } else {
      pintrk(track, eventName, payload);
    }
  }
}
